exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-mb[data-v-59fe239e]{margin-bottom:50px}.w-mb2[data-v-59fe239e]{margin-bottom:100px}", ""]);

// exports
